(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["catalog"]) return;
  try {
    
(()=>{
  const instances=new WeakMap();
  function init(scope=document){
    scope.querySelectorAll('[data-cover-carousel]').forEach(root=>{
      if(instances.has(root))return;
      const track=root.querySelector('[data-cover-track]');
      const slides=[...root.querySelectorAll('[data-cover-slide]')];
      const dots=[...root.querySelectorAll('[data-cover-dot]')];
      const toggle=root.querySelector('[data-cover-pause]');
      const status=root.querySelector('[data-cover-status]');
      const benefits=root.nextElementSibling;
      const collarBenefits=benefits?.classList.contains('strip')?[...benefits.children].map(item=>item.lastChild.textContent):[];
      const slideBenefits=[collarBenefits,['Water anywhere','Folds flat','Clip it and go'],['Lifts loose fur','Reusable design','More cuddle time']];
      const motion=matchMedia('(prefers-reduced-motion: reduce)');
      const abort=new AbortController();
      let index=0,timer=0,hover=false,focused=false,visible=true,start=null,disposed=false;
      let playing=root.dataset.autoplay==='true'&&!motion.matches;
      const delay=Math.max(4000,Number(root.dataset.interval)||6000);
      const on=(el,event,fn)=>el.addEventListener(event,fn,{signal:abort.signal});
      function label(){toggle.setAttribute('aria-label',playing?toggle.dataset.pauseLabel:toggle.dataset.playLabel);toggle.firstElementChild.textContent=playing?'Ⅱ':'▶';}
      function schedule(){clearTimeout(timer);if(playing&&!hover&&!focused&&!document.hidden&&visible&&!disposed)timer=setTimeout(()=>go(index+1),delay);}
      function go(next,manual=false){
        index=(next+slides.length)%slides.length;
        root.dataset.activeSlide=String(index);
        track.style.transform=`translateX(-${index*100}%)`;
        slides.forEach((slide,i)=>{slide.inert=i!==index;slide.setAttribute('aria-hidden',String(i!==index));});
        dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===index)));
        status.setAttribute('aria-live',manual?'polite':'off');
        status.textContent=dots[index].getAttribute('aria-label');
        if(benefits?.classList.contains('strip'))[...benefits.children].forEach((item,i)=>{item.lastChild.textContent=slideBenefits[index][i];});
        schedule();
      }
      root.classList.add('is-ready');
      root.querySelector('[data-cover-controls]').hidden=false;
      on(root.querySelector('[data-cover-prev]'),'click',()=>go(index-1,true));
      on(root.querySelector('[data-cover-next]'),'click',()=>go(index+1,true));
      dots.forEach((dot,i)=>on(dot,'click',()=>go(i,true)));
      on(toggle,'click',()=>{playing=!playing;label();schedule();});
      on(root,'pointerenter',e=>{if(e.pointerType==='mouse'){hover=true;schedule();}});
      on(root,'pointerleave',e=>{if(e.pointerType==='mouse'){hover=false;schedule();}});
      on(root,'focusin',()=>{focused=true;schedule();});
      on(root,'focusout',e=>{if(!root.contains(e.relatedTarget)){focused=false;schedule();}});
      on(document,'visibilitychange',schedule);
      on(motion,'change',()=>{if(motion.matches){playing=false;label();schedule();}});
      on(root,'keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(index+(e.key==='ArrowRight'?1:-1),true);}});
      on(root,'pointerdown',e=>{if(e.pointerType==='touch')start={x:e.clientX,y:e.clientY};});
      on(root,'pointerup',e=>{if(!start)return;const dx=e.clientX-start.x,dy=e.clientY-start.y;start=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)){go(index+(dx<0?1:-1),true);}});
      on(root,'pointercancel',()=>{start=null;});
      const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;schedule();},{threshold:.1});observer.observe(root);
      instances.set(root,()=>{disposed=true;clearTimeout(timer);abort.abort();observer.disconnect();instances.delete(root);});
      label();go(0);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-cover-carousel]').forEach(root=>instances.get(root)?.()));
})();


  } catch(e) { console.error(e); }
})();
})();
